import {ExtendBorrowFormContainer} from "../../../containers/borrowSystem/ChangeAndExtendBorrowForm/ExtendBorrowFormContainer"
export function ExtendBorrowFormPage () {
    return(
        <ExtendBorrowFormContainer/>
    )
}